import { useCallback } from 'react';
import { useWindowSize } from 'usehooks-ts';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { Navigation } from '@pcmp/react-coworker-components';

import { ROUTES } from '@/lib/constants';

const { BottomNavItem, BottomNavigation } = Navigation;

const NavBar = () => {
  const { width } = useWindowSize();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { pathname: route } = useLocation();
  const navigateTo = useCallback(
    (path: string) => () => navigate(path),
    [navigate]
  );
  const isMobile = width < 640;

  return (
    <div className="w-full fixed bottom-0 left-0 sm:hidden z-40">
      <BottomNavigation>
        {ROUTES.map(({ path, translationKey, icon, className }) => (
          <div
            className={`${
              isMobile ? className : ''
            } cw-w-full cw-h-full cw-pb-2 cw-flex-col cw-justify-start cw-items-center cw-gap-[5px] cw-inline-flex`}
            key={path}
          >
            <BottomNavItem
              key={path}
              text={t(translationKey)}
              icon={icon}
              onClick={navigateTo(path)}
              active={route === path}
            />
          </div>
        ))}
      </BottomNavigation>
    </div>
  );
};
export default NavBar;
